module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external "angular-promise-tracker"
// module id = 3
// module chunks = 0